import { render, staticRenderFns } from "./userInfo.vue?vue&type=template&id=d015dafc&scoped=true&"
import script from "./userInfo.vue?vue&type=script&lang=js&"
export * from "./userInfo.vue?vue&type=script&lang=js&"
import style0 from "./userInfo.vue?vue&type=style&index=0&id=d015dafc&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d015dafc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/wangmin/Projects/devidia_projects/devidia-p1-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d015dafc')) {
      api.createRecord('d015dafc', component.options)
    } else {
      api.reload('d015dafc', component.options)
    }
    module.hot.accept("./userInfo.vue?vue&type=template&id=d015dafc&scoped=true&", function () {
      api.rerender('d015dafc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/newRemoteGuidance/externalCall/sinoma/userInfo.vue"
export default component.exports